"use client";

import { Clock } from "lucide-react";

interface SlotCountdownTimerProps {
  formattedTime: string; // "MM:SS" format
  percentRemaining: number; // 0-100
  className?: string;
}

/**
 * Displays a countdown timer for slot reservation.
 * Shows time remaining to complete booking before slot selection expires.
 */
export function SlotCountdownTimer({
  formattedTime,
  percentRemaining,
  className = "",
}: SlotCountdownTimerProps) {
  // Determine color based on time remaining
  const isUrgent = percentRemaining <= 20; // Less than 1 minute (20% of 5 min)
  const isWarning = percentRemaining <= 40 && percentRemaining > 20; // 1-2 minutes

  const colorClasses = isUrgent
    ? "text-red-600 bg-red-50 border-red-200"
    : isWarning
    ? "text-amber-600 bg-amber-50 border-amber-200"
    : "text-green-600 bg-green-50 border-green-200";

  const iconColorClasses = isUrgent
    ? "text-red-500"
    : isWarning
    ? "text-amber-500"
    : "text-green-500";

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-sm font-medium ${colorClasses} ${className}`}
    >
      <Clock className={`h-4 w-4 ${iconColorClasses} ${isUrgent ? "animate-pulse" : ""}`} />
      <span>
        {formattedTime}
      </span>
      <span className="text-xs opacity-75">remaining</span>
    </div>
  );
}

export default SlotCountdownTimer;
